$('.clear-input').click(function (){
   $(this).siblings('input').val('');
   $(this).siblings('input').focus();
});